"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuPlannerQuery = void 0;
const client_1 = require("@apollo/client");
const menuNote_1 = require("../fragments/menuNote");
const menuItem_1 = require("../fragments/menuItem");
exports.menuPlannerQuery = client_1.gql `
  query MenuPlanner($startDate: String!, $endDate: String!) {
    menuPlanner(startDate: $startDate, endDate: $endDate) {
      ... on MenuItem {
        ...StandardMenuItem
      }
      ... on MenuNote {
        ...StandardMenuNote
      }
    }
  }
  ${menuNote_1.standardMenuNoteFragment}
  ${menuItem_1.standardMenuItemFragment}
`;
//# sourceMappingURL=menuPlanner.js.map